import { createContext, useContext } from "react";

import { TAuthStoreState, useStore } from "../../store";
import { getCookie } from "../../utils/cookies";

export type TAuthContext = TAuthStoreState | null;

const AuthContext = createContext<TAuthContext | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const user = useStore.use.user();
  const access_token =
    localStorage?.getItem("access_token") ?? getCookie("access_token") ?? "";
  const refresh_token =
    localStorage?.getItem("refresh_token") ?? getCookie("refresh_token") ?? "";
  return (
    <AuthContext.Provider value={{ user, access_token, refresh_token }}>
      {children}
    </AuthContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
